import React, { useEffect } from 'react';
import { Box, Text, Group, ThemeIcon, Stack } from '@mantine/core';
import { IconListDetails } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface GetTodoProps {
    onClose?: () => void;
    setInputValue?: (value: string) => void;
}

const GetTodo: React.FC<GetTodoProps> = ({ onClose }) => {
    const { t } = useTranslation(['ai']);
    return (
        <Box
            p="md"
            style={{
                maxWidth: '100%',
                display: 'flex',
                height: '494px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
            }}
        >
            <Stack align="center" gap="sm" style={{ textAlign: 'center' }}>
                <Group mb="sm">
                    <ThemeIcon
                        variant="light"
                        radius="xl"
                        size={22}
                        style={{
                            backgroundColor: '#E7F5FF',
                            padding: '2px',
                        }}
                    >
                        <IconListDetails size={20} color="#212529" />
                    </ThemeIcon>
                    <Text fw={600}>{t('features.getTodo.title')}</Text>
                </Group>
                <Text size="sm" color="dimmed" style={{ textAlign: 'center' }}>
                    {t('features.getTodo.description')}
                </Text>

                <Text size="sm" color="dimmed" style={{ textAlign: 'center' }}>
                    {t('features.getTodo.example1')}
                    <br />
                    {t('features.getTodo.example2')}
                </Text>
            </Stack>
        </Box>
    );
};

export default GetTodo;
